function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/input.ts
import { inputAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
import { getColor, mode } from "@chakra-ui/theme-tools";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var $height = cssVar("input-height");
var $fontSize = cssVar("input-font-size");
var $padding = cssVar("input-padding");
var $borderRadius = cssVar("input-border-radius");
var baseStyle = definePartsStyle({
  addon: {
    height: $height.reference,
    fontSize: $fontSize.reference,
    px: $padding.reference,
    borderRadius: $borderRadius.reference
  },
  field: {
    width: "100%",
    height: $height.reference,
    fontSize: $fontSize.reference,
    px: $padding.reference,
    borderRadius: $borderRadius.reference,
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
});
var size = {
  lg: defineStyle(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $fontSize.variable, "fontSizes.lg"), $padding.variable, "space.4"), $borderRadius.variable, "radii.md"), $height.variable, "sizes.12")),
  md: defineStyle(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $fontSize.variable, "fontSizes.md"), $padding.variable, "space.4"), $borderRadius.variable, "radii.md"), $height.variable, "sizes.10")),
  sm: defineStyle(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $fontSize.variable, "fontSizes.sm"), $padding.variable, "space.3"), $borderRadius.variable, "radii.sm"), $height.variable, "sizes.8")),
  xs: defineStyle(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $fontSize.variable, "fontSizes.xs"), $padding.variable, "space.2"), $borderRadius.variable, "radii.sm"), $height.variable, "sizes.6"))
};
var sizes = {
  lg: definePartsStyle({
    field: size.lg,
    group: size.lg
  }),
  md: definePartsStyle({
    field: size.md,
    group: size.md
  }),
  sm: definePartsStyle({
    field: size.sm,
    group: size.sm
  }),
  xs: definePartsStyle({
    field: size.xs,
    group: size.xs
  })
};
function getDefaults(props) {
  var fc = props.focusBorderColor,
    ec = props.errorBorderColor;
  return {
    focusBorderColor: fc || mode("blue.500", "blue.300")(props),
    errorBorderColor: ec || mode("red.500", "red.300")(props)
  };
}
var variantOutline = definePartsStyle(function (props) {
  var theme = props.theme;
  var _getDefaults = getDefaults(props),
    fc = _getDefaults.focusBorderColor,
    ec = _getDefaults.errorBorderColor;
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: mode("gray.300", "whiteAlpha.400")(props)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: getColor(theme, ec),
        boxShadow: "0 0 0 1px ".concat(getColor(theme, ec))
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: getColor(theme, fc),
        boxShadow: "0 0 0 1px ".concat(getColor(theme, fc))
      }
    },
    addon: {
      border: "1px solid",
      borderColor: mode("inherit", "whiteAlpha.50")(props),
      bg: mode("gray.100", "whiteAlpha.300")(props)
    }
  };
});
var variantFilled = definePartsStyle(function (props) {
  var theme = props.theme;
  var _getDefaults2 = getDefaults(props),
    fc = _getDefaults2.focusBorderColor,
    ec = _getDefaults2.errorBorderColor;
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: mode("gray.100", "whiteAlpha.50")(props),
      _hover: {
        bg: mode("gray.200", "whiteAlpha.100")(props)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: getColor(theme, ec)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: getColor(theme, fc)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: mode("gray.100", "whiteAlpha.50")(props)
    }
  };
});
var variantFlushed = definePartsStyle(function (props) {
  var theme = props.theme;
  var _getDefaults3 = getDefaults(props),
    fc = _getDefaults3.focusBorderColor,
    ec = _getDefaults3.errorBorderColor;
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: getColor(theme, ec),
        boxShadow: "0px 1px 0px 0px ".concat(getColor(theme, ec))
      },
      _focusVisible: {
        borderColor: getColor(theme, fc),
        boxShadow: "0px 1px 0px 0px ".concat(getColor(theme, fc))
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
});
var variantUnstyled = definePartsStyle({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
});
var variants = {
  outline: variantOutline,
  filled: variantFilled,
  flushed: variantFlushed,
  unstyled: variantUnstyled
};
var inputTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  variants: variants,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
});
export { inputTheme };